<template>
  <div>
    <el-carousel :interval="3000">
      <el-carousel-item v-for="carouselImage in carouselImages" :key="carouselImage.id">
        <img :src="carouselImage.path" class="carousel-image" alt="carouselImage"/>
      </el-carousel-item>
    </el-carousel>

    <el-tabs v-model="productType">
      <el-tab-pane v-for="productInfo in productInfos" :name="productInfo.type" :key="productInfo.id">
        <template #label><span class="tab-label">{{ productInfo.name }}</span></template>
        <div v-if="productInfo.type==='midFire'">
          <el-row>
            <el-col :span="12">
              <el-card shadow="hover" style="margin-top: 10px;margin-right: 10px;">
                <template #header>
                  <div style="font-size: 20px;text-align:center;" @click="handleToPage('/fire/MediumFireDeviceHome')">
                    理论真题
                    <el-link style="color: blue;float:right;margin-right: 30px;"
                             @click="handleToPage('/fire/MediumFireDeviceHome')">
                      >>免费试用
                    </el-link>
                  </div>
                </template>
                <el-row>

                  <img src="@/assets/picture/FireEngine/theoryIntroduce.png"
                       style="width: 600px;height: 900px"
                       alt="theoryHistory" @click="handleToPage('/fire/MediumFireDeviceHome')">

                </el-row>

              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="hover" style="margin-top: 10px;margin-right: 10px;">
                <template #header>
                  <div style="font-size: 20px;text-align:center;" @click="handleToPage('/fire/MediumFireDeviceHome')">
                    操作题(必考题+抽考题)
                    <el-link style="color: blue;float:right;margin-right: 30px;"
                             @click="handleToPage('/fire/MediumFireDeviceHome')">
                      >>免费试用
                    </el-link>
                  </div>
                </template>
                <el-row>
                  <img src="@/assets/picture/FireEngine/peopleIntroduce.png"
                       style="width: 600px;height: 900px"
                       alt="theoryHistory" @click="handleToPage('/fire/MediumFireDeviceHome')">
                </el-row>
              </el-card>
            </el-col>
          </el-row>

        </div>
      </el-tab-pane>
    </el-tabs>

    <!--    <el-row :gutter="10">-->
    <!--      <el-col :span="2" class="mode-col"></el-col>-->
    <!--      <el-col :span="4" v-for="modeImage in machineItemImages" :key="modeImage.id"-->
    <!--              :style="{ backgroundImage: `url(${modeImage.path})` }"-->
    <!--              @mouseenter="handleMachineMouseEnter(modeImage)"-->
    <!--              @mouseleave="handleMachineMouseLeave(modeImage)"-->
    <!--              class="mode-col">-->
    <!--        <div style="width: 200px;height: 300px; align-content: center">-->

    <!--          <div style="font-size: medium;text-align: center;vertical-align: center">-->
    <!--            <img :src="modeImage.icon" style="height: 100px;width: 100px;align-content: center;" alt="icon"/>-->
    <!--            <p/>{{ modeImage.title }}-->
    <!--          </div>-->
    <!--          <p></p>-->
    <!--          <div style="font-size: small;text-align: center;vertical-align: center">{{ modeImage.desc }}</div>-->
    <!--        </div>-->
    <!--      </el-col>-->
    <!--      <el-col :span="2" class="mode-col"></el-col>-->
    <!--    </el-row>-->


  </div>
</template>

<script>
// import cloneDeep from 'lodash/cloneDeep'

// const machineItemImages =
//     [{
//       id: 1,
//       path: require('@/assets/picture/main/mode/trainingModeBlue.png'),
//       title: "理论真题",
//       desc: "海量题库，在线学习",
//       icon: require('@/assets/picture/main/mode/ico/train.png')
//     },
//       {
//         id: 2,
//         path: require('@/assets/picture/main/mode/trainingModeGreen.png'),
//         title: "机考实操",
//         desc: "仿真国考，全面覆盖",
//         icon: require('@/assets/picture/main/mode/ico/mechine.png')
//       },
//       {
//         id: 3,
//         path: require('@/assets/picture/main/mode/trainingModeYellow.png'),
//         title: "人考模拟",
//         desc: "现场环境，模拟人考",
//         icon: require('@/assets/picture/main/mode/ico/personSpeak.png')
//       },
//       {
//         id: 4,
//         path: require('@/assets/picture/main/mode/trainingModeBlue.png'),
//         title: "国考模式",
//         desc: "仿真国考，精准押题",
//         icon: require('@/assets/picture/main/mode/ico/exam.png')
//       },
//       {
//         id: 5,
//         path: require('@/assets/picture/main/mode/trainingModeRed.png'),
//         title: "高频错题",
//         desc: "错题多刷，查漏补缺",
//         icon: require('@/assets/picture/main/mode/ico/errorRecord.png')
//       }];
// const machineItemImagesCopy = cloneDeep(machineItemImages)

import request from "@/utils/request";
import {ElMessage} from "element-plus";
import {ref} from "vue";
import router from "@/router";

async function getProductByStatus() {
  await request.get('/productInfo/', {
    params: {
      status: 'active'
    }
  })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          productInfos.value = result.data;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("getProductByAreaId error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

const productInfos = ref([]);
const productType = ref('midFire');
export default {
  name: "MainContent",
  async created() {
    await getProductByStatus.call(this);
  },
  data() {
    return {
      carouselImages:
          [{id: 1, path: require('@/assets/picture/main/carousel/1.png')},
            {id: 2, path: require('@/assets/picture/main/carousel/2.png')}
          ],
      productInfos: productInfos,
      productType: productType,
      // machineItemImages: machineItemImages,
    };
  },
  methods: {
    // handleMachineMouseEnter(modeImage) {
    //   this.machineItemImages[modeImage.id - 1].path = require('@/assets/picture/main/mode/trainingModeSelected.png')
    // },
    // handleMachineMouseLeave(modeImage) {
    //   modeImage.path = machineItemImagesCopy[modeImage.id - 1].path
    // },
    handleToPage(path) {
      router.push(path);
    },
  }
}
</script>

<style scoped>
.carousel-image {
  height: 300px;
  width: 100%;
}

/*.mode-col {*/
/*  height: 300px;*/
/*  width: 400px; !* 设置一个高度让背景显示出来 *!*/
/*  background-size: contain;*/
/*  background-repeat: no-repeat; !* 背景图片覆盖整个元素 *!*/
/*  transition: background-image 0.5s; !* 可选的，背景图变化过渡效果 *!*/
/*  align-content: center;*/
/*  background-color: lightgray;*/
/*}*/

.tab-label {
  font-size: 20px;
}
</style>
